import { useState, useEffect, useCallback } from 'react'
import { getAlertas, resolverAlerta, ignorarAlerta } from '@services/crud.js'
import { gerarAlertasAutomaticos } from '@services/alertasService.js'
import type { Alerta } from '@services/db.js'

export type { Alerta }

export interface AlertasData {
  alertas: Alerta[]
  alertasAtivos: Alerta[]
  alertasHistorico: Alerta[]
  totalAtivos: number
  isLoading: boolean
}

const INITIAL: AlertasData = {
  alertas: [],
  alertasAtivos: [],
  alertasHistorico: [],
  totalAtivos: 0,
  isLoading: true,
}

export function useAlertas(autoGerar = false) {
  const [data, setData] = useState<AlertasData>(INITIAL)

  const load = useCallback(async () => {
    const all = await getAlertas()
    const ativos = all.filter((a) => (a.status ? a.status === 'ativo' : !a.lido))
    const historico = all.filter((a) => (a.status ? a.status !== 'ativo' : a.lido))
    setData({
      alertas: all,
      alertasAtivos: ativos,
      alertasHistorico: historico,
      totalAtivos: ativos.length,
      isLoading: false,
    })
  }, [])

  useEffect(() => {
    const run = async () => {
      if (autoGerar) await gerarAlertasAutomaticos()
      await load()
    }
    run()
  }, [load, autoGerar])

  const resolver = useCallback(
    async (id: number) => {
      await resolverAlerta(id)
      await load()
    },
    [load],
  )

  const ignorar = useCallback(
    async (id: number) => {
      await ignorarAlerta(id)
      await load()
    },
    [load],
  )

  const gerar = useCallback(async () => {
    await gerarAlertasAutomaticos()
    await load()
  }, [load])

  return { ...data, reload: load, resolver, ignorar, gerar }
}
